<template>
    <v-main>
        <router-view />
    </v-main>
</template>

<script>
export default {
    name: "SharedCoreView",
    data() {
        return {
            transition: null,
            transitionMode: null,
        };
    },
};
</script>
